@if (form) {
  <nimbus-form-wrapper [formGroup]="form">
    <div class="settings-row">
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-dropdown
            [label]="TranslationKeys.AssistantSettingsPosition | translate"
            [options]="positions"
            [required]="true"
            id="position"
            formControlName="position"
            panelClass="assistant-settings-dropdown"
          >
          </nimbus-input-dropdown>
        </nimbus-form-control>
      </nimbus-form-row>
      @if (zoomEnabled) {
        <nimbus-form-row>
          <nimbus-form-control>
            <nimbus-input-dropdown
              [label]="TranslationKeys.AssistantSettingsZoom | translate"
              [options]="zoomLevels"
              [required]="true"
              id="zoom"
              formControlName="zoom"
              panelClass="assistant-settings-dropdown"
            >
            </nimbus-input-dropdown>
          </nimbus-form-control>
        </nimbus-form-row>
      }
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-slide-toggle
            id="bringToForeground"
            formControlName="bringToForeground"
            [label]="TranslationKeys.AssistantSettingsBringToForeground | translate"
          >
          </nimbus-input-slide-toggle>
        </nimbus-form-control>
      </nimbus-form-row>
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-slide-toggle id="topmost" formControlName="topmost" [label]="TranslationKeys.AssistantSettingsTopmost | translate">
          </nimbus-input-slide-toggle>
        </nimbus-form-control>
      </nimbus-form-row>
    </div>
  </nimbus-form-wrapper>
}
